var sw = window.innerWidth;
var sh = window.innerHeight;
var header = document.querySelector("header");
var sticky = 0;

// var HomeSlider = ["homeTrustedSlider", "homeServicesSlider", "VacanciesSlider", "TestimonialsSlider"];

// Font Resizer-------------------Start
function fontResizer() {
  var perc = parseInt(sw) / 118.9375;
  document.body.style.fontSize = perc + "px";
}

// Loader-------------------Start
function pageLoader() {
  setTimeout(function () {
    document.querySelector(".loader-first").style.display = "none";
    document.querySelector("html").classList.remove("loadjs");
  }, 700);
}

// Navigation Active-------------------Start
let toggleMenu = document.querySelector("#toggle");
let htmlEl = document.querySelector("html");

toggleMenu.addEventListener("click", (event) => {
  console.log("this", event);
  let _this = event.target;
  _this.classList.toggle("active");
  document.querySelector(".navigation").classList.toggle("open");
  htmlEl.classList.toggle("overflow-hidden");
});

// Home Section-------------------Start
let secondSection = document.querySelector(".perfect-solution__perfect-card");

if (secondSection) {
  secondSection.addEventListener("click", (event) => {
    console.log("this", event);
    let __this = event.target;
    document
      .querySelector(".perfect-solution__wardrobe-customization")
      .classList.toggle("active");
  });
}

var acc = document.getElementsByClassName("toggle-btnn");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].querySelector("p").addEventListener("click", function () {
    this.classList.toggle("opened");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    console.log("checking height", panel.style.maxHeight);
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

// Footer Mob Dropdown-----END

var accordion = document.getElementsByClassName("faqs__faq-accordion");
var j;

for (j = 0; j < accordion.length; j++) {
  accordion[j].querySelector("h4").addEventListener("click", function () {
    this.classList.toggle("opened");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    // console.log('checking height', panel.style.maxHeight)
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

// Landscape Mode off----------------Start
function landscapeModeOff() {
  if (sh < 450 && sw > 480 && sw < 820) {
    document.getElementById("portrait-warnning").style.display = "flex";
  } else {
    document.getElementById("portrait-warnning").style.display = "none";
  }
}

// Sticky Header----------------Start
function stickyHeader() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}

// if (sw < 767) {
//     if (document.querySelector('.our-partners__partner-slider')) {
//         var partnerSlider = new Swiper(".our-partners__partner-slider", {
//             slidesPerView: 2,
//             loop: true,
//             speed: 2000,
//             autoplay: {
//                 enable: true,
//                 delay: 2000,
//                 disableOnInteraction: false,
//             },
//         });
//     }
// }

// home hero image/video slider
if (document.querySelector(".home-hero__slider")) {
  var homeImage = new Swiper(".home-hero__slider", {
    slidesPerView: 1,
    loop: true,
    speed: 1800,
    allowTouchMove: false,
    observeParents: true,
    observer: true,
    effect: "creative",
    creativeEffect: {
      prev: {
        shadow: true,
        translate: ["-50%", 0, -1],
      },
      next: {
        translate: ["100%", 0, 0],
      },
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
  });
}

// feature slider
if (document.querySelector(".feature_slider")) {
  var featureSlider = new Swiper(".feature_slider", {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: false,
    speed: 2000,
    observeParents: true,
    observer: true,
    pauseOnMouseEnter: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
  });
}

// holiday homes slider
if (document.querySelector(".holiday_slider")) {
  var holidaySlider = new Swiper(".holiday_slider", {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: false,
    speed: 2000,
    observeParents: true,
    observer: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
  });
}

// home interior design slider
if (document.querySelector(".interior-designs_slider")) {
  var homeInterioreSlider = new Swiper(".interior-designs_slider", {
    slidesPerView: 1,
    loop: false,
    speed: 2000,
    observeParents: true,
    observer: true,
    spaceBetween: 20,
    autoplay: {
      delay: 1500,
      disableOnInteraction: false,
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: "auto",
        spaceBetween: 0,
      },
    },
  });
}

// blogs of home page slider
if (document.querySelector(".blogs-slider-wrapper")) {
  var homeBlogSlider = new Swiper(".blogs-slider-wrapper .blogs-slider", {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    speed: 2000,
    observeParents: true,
    observer: true,
    // autoplay: {
    //     delay: 1500,
    //     disableOnInteraction: false,
    // },
    navigation: {
      nextEl: ".blogs-slider-wrapper .swiper-button-next",
      prevEl: ".blogs-slider-wrapper .swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: "auto",
      },
    },
  });
}

// timeline history
if (document.querySelector(".history-timeline__slider")) {
  var timelineSlider = new Swiper(".history-timeline__slider > .swiper", {
    slidesPerView: "auto",
    loop: false,
    speed: 2000,
    observeParents: true,
    observer: true,
    watchSlidesProgress: true,
  });
}

// thumb of timeline history
if (document.querySelector(".historyContent")) {
  var timeThumbSlider = new Swiper(".historyContent > .swiper", {
    slidesPerView: 1,
    loop: false,
    speed: 2000,
    observeParents: true,
    observer: true,
    effect: "fade",
    grabCursor: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    thumbs: {
      swiper: timelineSlider,
    },
  });
}

// interior design page's sliders
if (document.querySelector(".interior-d__slider")) {
  var interiorSlider = new Swiper(".interior-d__slider > .swiper", {
    slidesPerView: 1,
    loop: true,
    speed: 2000,
    observer: true,
    observeParents: true,
    spaceBetween: 15,
    centeredSlides: true,
    watchSlidesProgress: true,
    // loopedSlidesLimit: false,
    // loopedSlides: 12,
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    navigation: {
      nextEl: ".interior-d__slider .swiper-button-next",
      prevEl: ".interior-d__slider .swiper-button-prev",
    },
    breakpoints: {
      576: {
        slidesPerView: "auto",
        spaceBetween: 0,
      },
    },
  });
}

// SVG Covert Code
if (document.querySelector('.svg-convert')) {
  let svgs = document.querySelectorAll("img.svg-convert");

  svgs.forEach((el) => {
    const imgID = el.getAttribute("id");
    const imgClass = el.getAttribute("class");
    const imgURL = el.getAttribute("src");

    fetch(imgURL)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(data, "text/html");
        let svg = xmlDoc.querySelector("svg");
        if (typeof imgID !== "undefined") {
          svg.setAttribute("id", imgID);
        }

        if (typeof imgClass !== "undefined") {
          svg.setAttribute("class", imgClass + " svg-converted");
        }

        svg.removeAttribute("xmlns:a");

        el.parentNode.replaceChild(svg, el);
      });
  });
}
// Window on Load-----------------Start
window.onload = function () {
  pageLoader();
  if (sw > 1025) {
    fontResizer();
  }
};

// Window On Resize-----------------Start
window.addEventListener("resize", (event) => {
  sw = window.innerWidth;
  sh = window.innerHeight;
  landscapeModeOff();
  if (sw > 1025) {
    if (sw < 1400 && sw > 1300 && sh > 900) {
    } else {
      fontResizer();
    }
  }
});

// Window On Resize-----------------End

// Window On Scroll-----------------Start
window.addEventListener("scroll", (event) => {
  stickyHeader();
});


// Window On Scroll-----------------End

// stop prevent
// let btnn = document.querySelector(".hero-form .hero-form__col--btnn");
// btnn.addEventListener("click", function (e) {
//   e.preventDefault();
// });

// home hero tabs
let h_tabs_item = document.querySelectorAll(".tabs--home-hero > .tabs__list .btnn"),
  tabs_list = document.querySelector(".tabs--home-hero > .tabs__list"),
  tabsRow = document.querySelector(".hero-form");

  if(tabs_list) {
    tabs_list.addEventListener("click", function(e) {
      let currentBtn = e.target;
      if(currentBtn.matches(".tabs--home-hero > .tabs__list .btnn")) {
        console.log("click btn home");
    
        if (currentBtn.classList.contains("active")) {
          return false;
        } else {
          for (let item of tabs_list.children) {
            item.classList.remove("active");
          }
          for (let row of tabsRow.children) {
            row.style.display = "none";
          }
          currentBtn.classList.toggle("active");
          let currentRowID = currentBtn.getAttribute("data-id"); // come property or holiday
          document.querySelector(`#${currentRowID}`).style.display = "flex";
        }
    
      }
    });
  }




// form field dropdown on hero

let formField = document.querySelectorAll(".hero-form__col .form-field, .hero-form__dropdown-icon"),
    formFieldDropdown = document.querySelectorAll(".hero-form__dropdown"),
    formApply = document.querySelectorAll(".hero-form__types__footer .btnn--icon"),
    niceSelectWrapper = document.querySelector(".form-field--location");


  formField.forEach(function (el, idx) {
    el.addEventListener("click", function (e) {
      e.stopPropagation();
      let currentField = e.target;
      let parentEl = currentField.closest(".hero-form__col");
      let currentDrop = parentEl.querySelector(".hero-form__dropdown");

      if(currentDrop) {
        let currentDropIs = currentDrop.classList.contains('active');
        formFieldDropdown.forEach(function (elmm) {
          elmm.classList.remove("active");
        });
  
        if(currentDropIs == false) {
          currentDrop.classList.add("active");
          if(niceSelectWrapper) {
            niceSelectWrapper.querySelector(".nice-select").classList.remove("open");
          }
        }
      }
    });
  });

  if(niceSelectWrapper) {
    niceSelectWrapper.addEventListener("click", function(e) {
      e.stopPropagation();
      
      formFieldDropdown.forEach(function (elmm) {
        elmm.classList.remove("active");
      });
    });
  }
   
  // close filter when click outside the dropdown filter
  document.addEventListener("click", function(e) {
    e.stopPropagation();
    if(e.target.closest(".hero-form__dropdown")) {

    }
    else {
      formFieldDropdown.forEach(function(ffd) {
        ffd.classList.remove("active");
        niceSelectWrapper.querySelector(".nice-select").classList.remove("open");
        console.log("check")
      });
    }
  });




  // dropdown close for apply button
  formApply.forEach(function(btnn) {
    btnn.addEventListener("click", function(envt) {
      envt.stopPropagation();
      let currentDropdown = envt.target.closest(".hero-form__dropdown");
      currentDropdown.classList.toggle("active");
    });
  });




// clear selected values on click
(function() {
  window.addEventListener("load", function() {
    if(document.querySelector(".hero-form__types--sm")) {
          let selectSelected = document.querySelector(".hero-form__types--sm"),
              smallSelect = selectSelected.getElementsByClassName("select-selected"),
              hero_form__types_area = document.querySelector(".hero-form__types--area"),
              firstSingleArea = hero_form__types_area.getElementsByClassName("select-selected")[0],
              secondSingleArea = hero_form__types_area.getElementsByClassName("select-selected")[1],
              hero_form__types_price = document.querySelector(".hero-form__types--price"),
              firstPrice = hero_form__types_price.getElementsByClassName("select-selected")[0],
              secondPrice = hero_form__types_price.getElementsByClassName("select-selected")[1],
              clearValuesBtn = document.querySelector(".clear-values");
          clearValuesBtn.addEventListener("click", function(e) {
            e.stopPropagation();
            for (const singleSelect of smallSelect) {
              singleSelect.textContent = "select";
            }
            firstSingleArea.textContent = "Minimum";
            secondSingleArea.textContent = "Maximum";
            firstPrice.textContent = "Minimum";
            secondPrice.textContent = "Maximum";

          });
    }
  });
})();


// hero iframe add on a time
// (function() {
//   let home_hero__video__panel = document.querySelector(".home-hero__video__panel");
//   let frame = document.createElement("iframe");
//   frame.setAttribute("src", "abc");
//   home_hero__video__panel.appendChild(frame);
// })();




// custom 
const select = document.querySelectorAll(".selectbtnn");
const option = document.querySelectorAll(".option");
let index = 1;

// select btnn
select.forEach((a) => {
  a.addEventListener("click", (b) => {
    let dropdown = document.querySelectorAll(".selectDropdown");

    for (const dp of dropdown) {
      dp.classList.remove("toggle");
    }

    const next = b.target.nextElementSibling;
    next.classList.toggle("toggle");
    next.style.zIndex = index++;
  });
});

// select dropdown
option.forEach((a) => {
  a.addEventListener("click", (b) => {
    b.target.parentElement.classList.remove("toggle");

    const parent = b.target.closest(".select").children[1];
    parent.setAttribute("data-type", b.target.getAttribute("data-type"));
    parent.innerText = b.target.innerText;
  });
});



// custom calendar initialization
if (document.querySelectorAll(".vanilla-calendar").length > 0) {

  document.addEventListener("DOMContentLoaded", function() {
    const inputStaticEl = document.querySelector('#calendar1-input-field');
    const calendarDatepickerStatic = new VanillaCalendar('#calendar1', {
      actions: {
        clickDay(event, dates) {
          inputStaticEl.value = dates;
        },
      },
    });
    calendarDatepickerStatic.init();


    // calendar 2
    const inputStaticEl2 = document.querySelector('#calendar2-input-field');
    const calendarDatepickerStatic2 = new VanillaCalendar('#calendar2', {
      actions: {
        clickDay(event, dates) {
          inputStaticEl2.value = dates;
        },
      },
    });
    calendarDatepickerStatic2.init();


    if (location.pathname == "/holiday-homes-detail.php") {
      // calendar3
      const inputStaticEl3 = document.querySelector('#calendar3-input-field');
      const calendarDatepickerStatic3 = new VanillaCalendar('#calendar3', {
        actions: {
          clickDay(event, dates) {
            inputStaticEl3.value = dates;
          },
        },
      });
      calendarDatepickerStatic3.init();
      
    }


  });


}



// set value with calendar date
// let calendarDays = document.querySelectorAll(".vanilla-calendar-day");
// calendarDays.forEach(function (cld) {
//   // console.log(cld)
//   cld.addEventListener("click", function (env) {
//     let currentDay = env.target;
    
//     let mainCol =
//       currentDay.parentElement.parentElement.parentElement.parentElement
//         .parentElement;
//     // mainCol.children[0]
//     console.log(mainCol.children[0].children[0]);
//     let currentInput = mainCol.children[0].children[0];

//     currentInput.setAttribute("value", currentDay.dataset.calendarDay);

//     let currentCalendarDropdown =
//       currentDay.parentElement.parentElement.parentElement.parentElement;
//     currentCalendarDropdown.classList.remove("active");
//   });
// });



// custom select to
(function () {
  var x, i, j, l, ll, selElmnt, a, b, c;
  /*look for any elements with the class "custom-select":*/
  x = document.getElementsByClassName("custom-select");
  l = x.length;
  for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    /*for each element, create a new DIV that will act as the selected item:*/
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /*for each element, create a new DIV that will contain the option list:*/
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 1; j < ll; j++) {
      /*for each option in the original select element,
    create a new DIV that will act as an option item:*/
      c = document.createElement("DIV");
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.addEventListener("click", function (e) {
        /*when an item is clicked, update the original select box,
        and the selected item:*/
        var y, i, k, s, h, sl, yl;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        sl = s.length;
        h = this.parentNode.previousSibling;
        for (i = 0; i < sl; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            yl = y.length;
            for (k = 0; k < yl; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
      });
      b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function (e) {
      /*when the select box is clicked, close any other select boxes,
      and open/close the current select box:*/
      let heroformDropdown = document.querySelectorAll(".hero-form__col:not(.hero-form__col--btnn) .hero-form__dropdown");
      heroformDropdown.forEach(function (elmt) {
        elmt.classList.remove("active");
      });

      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
    });
  }
  function closeAllSelect(elmnt) {
    /*a function that will close all select boxes in the document,
  except the current select box:*/
    var x,
      y,
      i,
      xl,
      yl,
      arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i);
      } else {
        y[i].classList.remove("select-arrow-active");
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add("select-hide");
      }
    }
  }
  /*if the user clicks anywhere outside the select box,
then close all select boxes:*/
  document.addEventListener("click", closeAllSelect);
})();


// page active link
(function () {
  window.addEventListener("load", function (e) {
    if (this.location.pathname == "/") {
      console.log("home page")
    }
    else {
      let myPage = location.pathname,
        link = document.querySelector(`.menu__menuitem--menulink[href="${myPage}"]`);
        if(link) {
          link.classList.add("active");
        }
    }
  });

})();


// home about slider
var swiperHomeAbout = new Swiper(".home-about-us__slider", {
  spaceBetween: 20,
  speed: 1500,
  slidesPerView: 1,
  loop: true,
  grabCursor: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".home-about-us__slider .swiper-button-next",
    prevEl: ".home-about-us__slider .swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 50,
    },

  },
});


// Press Release slider ---------------- Start
if (document.querySelector('.js_reviewsSlider')) {
  var feedSlider = new Swiper('.js-reviewsSlider', {
    slidesPerView: 1,
    slidesPerColumn: 1,
    spaceBetween: 30,
    allowTouchMove: true,
    grabCursor: true,
    speed: 2000,
    // centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        //   spaceBetween: 20,
      },
      768: {
          slidesPerView: 2,
          //   spaceBetween: 40,
      },
      // 992: {
      //   slidesPerView: 2,
      //   //   spaceBetween: 40,
      // },
      1280: {
        slidesPerView: 3,
        //   spaceBetween: 50,
      },

      1680: {
        slidesPerView: 3,
        //   spaceBetween: 50,
      },
    },
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true,
    // },
    // navigation: {
    //   nextEl: '.js_press_releaseSlider .swiper-button-next',
    //   prevEl: '.js_press_releaseSlider .swiper-button-prev',
    // },
  })
}
// Press Release slider ---------------- End



// mortgage calculator
(function() {
  if(document.querySelector("#loanRange")) {
    let loan_Slider = document.querySelector("#loanRange"),
      down_Slider = document.querySelector("#downPayment"),
      loanPeriod_Slider = document.querySelector("#loanPeriod"),
      intrestRate_Slider = document.querySelector("#intrestRate");
  
      let loan_amount = document.querySelectorAll(".mortgage .loan_amount"),
          down_payment = document.querySelectorAll(".mortgage__left-panel .down_payment"),
          loan_period = document.querySelectorAll(".mortgage .loan_period"),
          interest_rate = document.querySelectorAll(".mortgage .interest_rate"),
          monthly_payment = document.querySelector(".mortgage__payment__title .value");

    // number format into commas
    function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function updateCalc() {
         // get and set on inital state value of input range
        let getLoanAmount = loan_amount.innerHTML = loan_Slider.value,
            getDownPayment = down_payment.innerHTML = down_Slider.value,
            getLoanPeriod = loan_period.innerHTML = loanPeriod_Slider.value,
            getIntrestRate = interest_rate.innerHTML = intrestRate_Slider.value;


        var amt = getLoanAmount - getDownPayment;
            getLoanPeriod *= 12;
            getIntrestRate /= 1200;
        var payment = (amt * (getIntrestRate * Math.pow(1 + getIntrestRate, getLoanPeriod))) / (Math.pow(1 + getIntrestRate, getLoanPeriod) - 1);
        let paymentTofixed =  payment.toFixed(2);
            monthly_payment.innerHTML = numberWithCommas(paymentTofixed);
    }
     
    
  
    loan_Slider.addEventListener("input", function(e) {
      loan_amount.forEach(function(la) {
        let currentNum = e.target.value;
        la.innerHTML = numberWithCommas(currentNum);
      });
      updateCalc();
    });
  
    down_Slider.addEventListener("input", function(e) {
      down_payment.forEach(function(dp) {
        let currentNum = e.target.value;
        dp.innerHTML = numberWithCommas(currentNum);
      });
      updateCalc();
    });

    loanPeriod_Slider.addEventListener("input", function(e) {
      loan_period.forEach(function(lp) {
        lp.innerHTML = e.target.value;
      });
      updateCalc();
    });

    intrestRate_Slider.addEventListener("input", function(e) {
      interest_rate.forEach(function(ir) {
        ir.innerHTML = e.target.value;
      });
      updateCalc();
    });

  }
  
})();



window.addEventListener("DOMContentLoaded" , function() {
  (function() {

    if(niceSelectWrapper) {
      NiceSelect.bind(document.getElementById("searchable-select"), {searchable: true, placeholder: 'select', searchtext: 'location', selectedtext: 'geselecteerd' });
    }

  })();
});




